function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Return = function Return(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "m22.68 18.89.002-.057a1 1 0 0 1-.26.673l-2.611 2.869a.996.996 0 0 1-1.412.066 1 1 0 0 1-.067-1.412l1.088-1.197H4c-1.654 0-3-1.345-3-3v-3.99a1 1 0 1 1 2 0v3.99c0 .553.45 1 1 1h15.48l-1.148-1.263a1 1 0 0 1 .067-1.412 1 1 0 0 1 1.412.066l2.61 2.87c.184.2.27.455.26.706l.001.034v.012zM5.286 1.26a1 1 0 0 1 .067 1.412l-1.09 1.195 15.42.001c1.654 0 3 1.345 3 3v3.99a1 1 0 1 1-2 0V6.87c0-.552-.449-1-1-1H4.2l1.15 1.264a1 1 0 1 1-1.478 1.346L1.26 5.609A1 1 0 0 1 1 4.903v-.046l.001-.04v.052a1 1 0 0 1 .26-.673l2.61-2.869a1 1 0 0 1 1.414-.066"
  }));
};
export default Return;